import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function motorista(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@motorista/FIND_MOTORISTA':
      case '@motorista/UPDATE_MOTORISTA':
      case '@motorista/DELETE_MOTORISTA':
      case '@motorista/STORE_MOTORISTA':
      case '@motorista/MOTORISTAS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@motorista/SUCCESS_REMOVE':
      case '@motorista/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@motorista/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.motoristas;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@motorista/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.motorista;
        break;
      }

      case '@motorista/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
